var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.loadingStates.isLoadingBox)?_c('WaitingBlock'):(_vm.box && _vm.box.trackFilters)?_c('Filters',{attrs:{"type":"box","addDefault":true,"filters":_vm.box.trackFilters,"filteredBoxes":_vm.box.filteredBoxes},on:{"save":_vm.save}}):_c('div',[_vm._v(" No filters for this box ")])
}
var staticRenderFns = []

export { render, staticRenderFns }